export default __webpack_public_path__ + "static/media/Screens.0e35e903.webp";